"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HeaderCell_styles_1 = require("./HeaderCell.styles");
const HeaderCell = (props) => {
    const { children, fixed = false } = props, restProps = __rest(props, ["children", "fixed"]);
    if (fixed) {
        const _a = restProps, { width, minWidth, maxWidth, top } = _a, finalProps = __rest(_a, ["width", "minWidth", "maxWidth", "top"]);
        return (react_1.default.createElement(HeaderCell_styles_1.StyledHeaderCellFixed, Object.assign({ top: top, minWidth: minWidth, maxWidth: maxWidth, width: width }, finalProps), children));
    }
    const _b = restProps, { minWidth, maxWidth, top } = _b, finalProps = __rest(_b, ["minWidth", "maxWidth", "top"]);
    return (react_1.default.createElement(HeaderCell_styles_1.StyledHeaderCellAuto, Object.assign({ top: top, minWidth: minWidth, maxWidth: maxWidth }, finalProps), children));
};
exports.default = HeaderCell;
//# sourceMappingURL=HeaderCell.js.map